module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/persional-seperation-1.7219f7d7.png";